import React, { Component} from "react";
import queryString from "query-string";
import TokenHelper from "../components/TokenHelper";
//import PropTypes from "prop-types";

import superWordBlack from "../img/super-word-rgb.png";

import iconHamburger from "../img/icon-hamburger.png";

import "@progress/kendo-theme-material/dist/all.css";

import { isEmpty } from "../helpers";

import isPage from "../hoc/isPage";
import Sidebar from '../components/Sidebar';

import { AppContext } from "../context/AppContext";




class StandardLayout extends Component {
    pageKey;

    constructor(props) {
        super(props)
        this.handleLanguageChange = this.handleLanguageChange.bind(this)
      }

    state = {
        language: "en",
      };

    handleLanguageChange = (event) => {
        this.setState({
            language: event.target.value,
            });
        };

    handleToggleMenu = e => {
        this.context.handleToggleMenu();
    };

    handleCloseMenu = () => {

        this.context.setState({
            isNavBarVisible: false
        });
    }

    getPageKey = () => {
        // get the first fragment of the URL path
        // e.g. if the path is "/reports/top-seller-parts&reportTitle=Top%20Seller%20Parts", then
        // the first fragment would be "reports"

        let pageKey = "";

        const urlFragments = queryString.parse(window.location.pathname);

        if (!isEmpty(urlFragments)) {
            const keys = Object.keys(urlFragments);

            if (!isEmpty(keys)) {
                pageKey = keys[0]
                    .split("/")
                    .filter(fragment => fragment.length > 0)
                    .join(' ');
            }
        }

        return pageKey;
    }

    componentDidMount() {
        if (this.context.state.userID) {
            // begin of FreshDesk
            //window.FreshWidget.init("",
            //    {
            //        "queryString": `&widgetType=popup&submitTitle=Send&submitThanks=Hang+in+there!+We+will+be+in+touch+shortly&captcha=yes&helpdesk_ticket[requester]=${this.context.state.email}&helpdesk_ticket[custom_field][user_id]=${this.context.state.userID}&helpdesk_ticket[custom_field][language_code]=${this.context.state.languageCode}&helpdesk_ticket[custom_field][first_name]=${this.context.state.firstName}&helpdesk_ticket[custom_field][last_name]=${this.context.state.lastName}`,
            //        "utf8": "✓",
            //        "widgetType": "popup",
            //        "buttonType": "text",
            //        "buttonText": "Support",
            //        "buttonColor": "white",
            //        "buttonBg": "#009CEF",
            //        "alignment": "2",
            //        "offset": "500px",
            //        "submitThanks": "Hang in there! We will be in touch shortly",
            //        "formHeight": "500px",
            //        "captcha": "yes",
            //        "url": "https://thesuperco.freshdesk.com",
            //        "loadOnEvent": 'immediate'
            //    });

            // updated script got from FreshDesk
            //window.FreshWidget.init("",
            //    {
            //        "queryString": "&widgetType=popup&captcha=yes",
            //        "utf8": "✓",
            //        "widgetType": "popup",
            //        "buttonType": "text",
            //        "buttonText": "Support",
            //        "buttonColor": "white",
            //        "buttonBg": "#006063",
            //        "alignment": "4",
            //        "offset": "235px",
            //        "formHeight": "500px",
            //        "captcha": "yes",
            //        "url": "https://thesuperco.freshdesk.com",
            //        "loadOnEvent": 'immediate'
            //    });

            window.FreshWidget.init("",
                {
                    "queryString": `&widgetType=popup&captcha=yes&helpdesk_ticket[requester]=${this.context.state.email}&helpdesk_ticket[custom_field][user_id]=${this.context.state.userID}&helpdesk_ticket[custom_field][language_code]=${this.props.uiLanguage}&helpdesk_ticket[custom_field][first_name]=${this.context.state.firstName}&helpdesk_ticket[custom_field][last_name]=${this.context.state.lastName}`,
                    "utf8": "✓",
                    "widgetType": "popup",
                    "buttonType": "text",
                    "buttonText": "Support",
                    "buttonColor": "white",
                    "buttonBg": "#00a1db",
                    "alignment": "2",
                    "offset": "300px",
                    "formHeight": "520px",
                    "captcha": "yes",
                    "url": "https://thesuperco.freshdesk.com",
                    "loadOnEvent": 'immediate'
                });

            //function showWhenHTML2CanvasIsAvailable() {
            //    if (window.html2canvas) {
            //        window.FreshWidget.show();
            //    } else {
            //        setTimeout(showWhenHTML2CanvasIsAvailable, 100);
            //    }
            //}

            //showWhenHTML2CanvasIsAvailable();
            // end of FreshDesk
        }
    }

    render() {
        //const { language } = this.state;
        let pageKey = this.getPageKey();

        // make it so that if the navbar is open, then clicking anywhere else on the screen will close the navbar
        let closeMenuBehaviour = {};
        if (this.context.state.isNavBarVisible) {
            closeMenuBehaviour = {
                onClick: this.handleCloseMenu
            };
        }

        return (
            <React.Fragment>
                <TokenHelper />
                <AppContext.Consumer>
                    {context => (
                        //<LocalizationProvider language={context.state.uiLanguage}>
                        <div className="app-container" {...closeMenuBehaviour}>
                            <Sidebar handleLanguageChange = {this.handleLanguageChange}/>
                            <header>
                                <img
                                    src={iconHamburger}
                                    className="hamburger"
                                    onClick={this.handleToggleMenu}
                                    alt=""
                                />
                                <img className="logo" src={superWordBlack} alt="" />
                                <h2>SOM</h2>
                            </header>
                            <main className={`app-content ${pageKey}`}>
                                {React.cloneElement(this.props.children)}
                            </main>
                        </div>
                        //</LocalizationProvider>
                    )}
                </AppContext.Consumer>
            </React.Fragment>
        );
    }
}


export default isPage(StandardLayout);

StandardLayout.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/containers/StandardLayout.js